<div class="irembogov-change-request-configuration-header-widget">
  <header class="d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center">
      <span
        class="list-services-back-button h5 me-2 mb-0 border-end align-self-center"
        placement="end"
        ngbTooltip="Back to List of Services"
        (click)="goBackToServices()">
        <i class="fa-solid fa-angles-left me-2"></i>
      </span>
      <span class="me-2"
        ><i aria-hidden="true" class="fas fa-file-lines"></i
      ></span>
      <span
        class="requirement-doc-link cursor"
        (click)="OnClickRequirementDoc.emit(true)">
        Requirement Doc
      </span>
    </div>

    <div *ngIf="request">
      <div>
        <span class="me-2">{{ request.serviceName }}</span>
        <span>
          <irembogov-service-change-request-type-badge
            [requestType]="
              request.type
            "></irembogov-service-change-request-type-badge>
        </span>
      </div>
      <p class="mb-0 text-center">
        {{ formPersistenceStatus }}
        <i
          *ngIf="formPersistenceStatus === 'Saving Changes...'"
          class="fas fa-spinner fa-spin"></i>
      </p>
    </div>

    <div>
      <span
        class="d-flex align-items-center {{
          jsonFormFields ? [] : 'opacity-50'
        }}">
        <button
          *ngIf="showBuilderVersionToggle"
          class="btn btn-sm btn-outline-primary me-3 opacity-100"
          (click)="toggleBuilderVersion.emit()">
          <i
            [class]="
              useV2Builder
                ? 'fa-solid fa-arrow-rotate-left'
                : 'fa-solid fa-wand-magic-sparkles'
            "></i>
          {{ useV2Builder ? 'Switch to Classic Builder' : 'Try New Builder' }}
        </button>
        Preview Form
        <irembogov-basic-toggle-switch
          (switchChanged)="OnPreviewClick.emit($event)"
          uniqueId="previewRef"
          [disabled]="
            jsonFormFields ? false : true
          "></irembogov-basic-toggle-switch>
        <button
          *ngIf="request?.serviceId"
          class="btn btn-outline-info"
          (click)="openChoosePortalModal()">
          Test Service
          <i class="bi bi-box-arrow-up-right"></i>
        </button>
        <button
          *ngIf="readyForSaveSubmit && !request.serviceId"
          class="btn btn-warning"
          (click)="OnPrepareForTesting.emit(true)">
          Prepare For Testing
        </button>

        <ng-container *ngIf="!inReviewMode">
          <button class="save sm-btn mx-2" (click)="OnSaveAndClose.emit(true)">
            Save & Close
            <i
              *ngIf="isSaveAndCloseLoading"
              aria-hidden="true"
              class="fas fa-spinner fa-spin ms-2"></i>
          </button>
          <button
            class="submit sm-btn btn"
            [disabled]="!readyForSaveSubmit"
            (click)="OnSaveSubmit.emit(true)">
            Submit to QA
          </button>
        </ng-container>
      </span>
    </div>
  </header>
</div>

<ng-template #choosePortalModal let-modal>
  <div class="choose-portal-modal">
    <div class="modal-header">
      <h5 class="modal-title">Select Portal</h5>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
      <p class="mb-4">
        Please select the portal you want to test this service on.
      </p>
      <div class="d-flex flex-column gap-2">
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            id="citizen-portal"
            [value]="
              environment.testPortalUrls.citizen +
              '/dev/service/details?id=' +
              request.serviceId +
              '&changeRequestId=' +
              request.id +
              '&debugMode=' +
              request.debugMode
            "
            [formControl]="portalFormControl" />
          <label class="form-check-label" for="citizen-portal"
            >Citizen Portal</label
          >
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            id="iremboplus-portal"
            [value]="
              environment.testPortalUrls.iremboPlus +
              '/dev/organizations/' +
              request.organizationId +
              '/services?changeRequestId=' +
              request.id +
              '&debugMode=' +
              request.debugMode
            "
            [formControl]="portalFormControl" />
          <label class="form-check-label" for="iremboplus-portal"
            >Irembo Plus</label
          >
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            id="osc-portal"
            [value]="
              environment.testPortalUrls.rdbOsc +
              '/dev/service/' +
              request.serviceId +
              '?changeRequestId=' +
              request.id +
              '&debugMode=' +
              request.debugMode
            "
            [formControl]="portalFormControl" />
          <label class="form-check-label" for="osc-portal">RDB OSC</label>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-outline-dark"
        (click)="modal.dismiss()">
        Close
      </button>
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="!portalFormControl.valid"
        (click)="modal.close(portalFormControl.value)">
        Test Service
      </button>
    </div>
  </div>
</ng-template>
